/**
 * The wait a 429 names, in milliseconds (decision 81): the `Retry-After` header in seconds, which the backend's CORS
 * setup exposes to the page, else the body's `responseMetadata.statusData.retryAfterSeconds` (the backend sends both,
 * the same whole number); null when neither says.
 */
export function retryAfterMs(response: Response, rawBody: string): number | null {
  const header = Number(response.headers.get("Retry-After") ?? Number.NaN);
  if (Number.isFinite(header) && header >= 0) return header * 1000;
  try {
    const parsed = JSON.parse(rawBody) as { responseMetadata?: { statusData?: { retryAfterSeconds?: unknown } } } | null;
    const seconds = parsed?.responseMetadata?.statusData?.retryAfterSeconds;
    return typeof seconds === "number" && Number.isFinite(seconds) && seconds >= 0 ? seconds * 1000 : null;
  } catch {
    return null;
  }
}
